import moment from "moment";
import { Box, IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { STATE_LIST } from "../../../../utils/state-list";
export const InfantCareTrackingHeaderConfig = [
  {
    label: "OEM",
    id: "oem",
    render: (data) => <span>{data?.oem?.name}</span>,
  },
  {
    label: "Customer Contact Number",
    id: "customerContactNumber",
  },
  { label: "Action Taken", id: "actionTaken" },
  {
    label: "Complaints",
    id: "complaintsIfAny",
  },
  {
    label: "Customer Feedback Remarks",
    id: "customerFeedbackRemarks",
  },
  { label: "Customer Name", id: "customerName" },
  {
    label: "Date Of Sale",
    id: "dateOfSale",
    render: (data) => {
      return (
        <span>
          {data?.dateOfSale && moment(data.dateOfSale).format("DD/MM/YYYY")}
        </span>
      );
    },
  },
  {
    label: "Date Of Visit",
    id: "dateOfVisit",
    render: (data) => {
      return (
        <span>
          {data?.dateOfVisit && moment(data.dateOfVisit).format("DD/MM/YYYY")}
        </span>
      );
    },
  },

  {
    label: "Engine Model",
    id: "engineModel",
  },
  { label: "Engine Serial Number", id: "engineSerialNumber" },
  {
    label: "Fuel Filter",
    id: "fuelFilter",
  },
  {
    label: "Implements Used",
    id: "implementsUsed",
  },
  {
    label: "Machine Location",
    id: "machineLocation",
  },
  { label: "Machine Model", id: "machineModel" },
  { label: "Machine Serial Number", id: "machineSerialNumber" },
  { label: "Observation", id: "observation" },
  {
    label: "Oil Filter Make",
    id: "oilFilterMake",
  },
  { label: "Remarks", id: "remarks" },
  { label: "State", id: "state" },
  { label: "Total Running Hours", id: "totalRunningHours" },
  {
    label: "Action",
    id: "action",
    render: (data, onClick) => (
      <Box sx={{ display: "flex" }}>
        <>
          <IconButton onClick={() => onClick("EDIT", data)}>
            <EditIcon color="primary" />
          </IconButton>
          <IconButton>
            <DeleteIcon color="error" onClick={() => onClick("DELETE", data)} />
          </IconButton>
        </>
      </Box>
    ),
  },
];
export const EXHAUST_SMOKE_CONDITIONS = [
  { label: "Not Visible", value: "NOT_VISIBLE" },
  { label: "Black", value: "BLACK" },
  { label: "Blue", value: "BLUE" },
  { label: "White", value: "WHITE" },
];
export const STATUS_OPTIONS = [
  { label: "ACTIVE", value: "ACTIVE" },
  { label: "IN ACTIVE", value: "IN_ACTIVE" },
];

export const editInfantFormConfig = (oemsList = [], complaintCodes = []) => [
  {
    name: "oem",
    type: "autocomplete",
    label: "OEM Org",
    options: oemsList,
    placeholder: "Select Org",
    required: true,
  },
  {
    name: "engineSerialNumber",
    type: "text",
    label: "Engine Serial Number",
    placeholder: "Enter Engine Serial Number",
    required: true,
  },
  {
    name: "engineModel",
    type: "text",
    label: "Engine Model",
    placeholder: "Enter Engine Model",
    required: true,
  },
  {
    name: "machineSerialNumber",
    type: "text",
    label: "Machine Serial Number",
    placeholder: "Enter Machine Serial Number",
    required: true,
  },
  {
    name: "machineModel",
    type: "text",
    label: "Machine Model",
    placeholder: "Enter Machine Model",
    required: true,
  },
  {
    name: "dateOfSale",
    type: "datePicker",
    label: "Date of Sale",
    placeholder: "Select Date of Sale",
    required: true,
  },
  {
    name: "customerName",
    type: "text",
    label: "Customer Name",
    placeholder: "Enter Customer Name",
    required: true,
  },
  {
    name: "customerContactNumber",
    type: "text",
    label: "Customer Contact Number",
    placeholder: "Enter Customer Contact Number",
    required: true,
  },
  {
    name: "dateOfVisit",
    type: "datePicker",
    label: "Date of Visit",
    placeholder: "Select Date of Visit",
    required: true,
  },
  {
    name: "totalRunningHours",
    type: "number",
    label: "Total Running Hours",
    placeholder: "Enter Total Running Hours",
    required: true,
  },
  {
    name: "machineLocation",
    type: "text",
    label: "Machine Location",
    placeholder: "Enter Machine Location",
    required: true,
  },
  {
    name: "state",
    type: "autocomplete",
    label: "State",
    options: STATE_LIST,
    placeholder: "Select State",
    required: true,
  },
  {
    name: "oilFilterMake",
    type: "text",
    label: "Oil Filter Make",
    placeholder: "Enter Oil Filter Make",
  },
  {
    name: "fuelFilter",
    type: "text",
    label: "Fuel Filter",
    placeholder: "Enter Fuel Filter",
  },
  {
    name: "dataSetId",
    type: "text",
    label: "Dataset ID",
    placeholder: "Enter Dataset ID",
  },
  {
    name: "ecuSoftwareVersion",
    type: "text",
    label: "ECU Software Version",
    placeholder: "Enter ECU Software Version",
  },
  {
    name: "vinNo",
    type: "text",
    label: "VIN No",
    placeholder: "Enter VIN No",
  },
  {
    name: "hrsInObdTool",
    type: "text",
    label: "Hrs. in OBD Tool",
    placeholder: "Enter Hours in OBD Tool",
  },
  {
    name: "prvDuration",
    type: "text",
    label: "PRV Duration",
    placeholder: "Enter PRV Duration",
  },
  {
    name: "prvCount",
    type: "text",
    label: "PRV Count",
    placeholder: "Enter PRV Count",
  },
  {
    name: "hmiNo",
    type: "text",
    label: "HMI No",
    placeholder: "Enter HMI No",
  },
  {
    name: "exhaustSmokeCondition",
    type: "autocomplete",
    label: "Exhaust Smoke Condition",
    options: EXHAUST_SMOKE_CONDITIONS,
    placeholder: "Select Exhaust Smoke Condition",
  },
  ...[1, 2, 3, 4].map((i) => ({
    name: `iqaOnInjectorCylinder${i}`,
    type: "text",
    label: `IQA on Injector - Cylinder ${i}`,
    placeholder: `Enter IQA on Injector - Cylinder ${i}`,
  })),
  ...[1, 2, 3, 4].map((i) => ({
    name: `iqaInEcuCylinder${i}`,
    type: "text",
    label: `IQA in ECU - Cylinder ${i}`,
    placeholder: `Enter IQA in ECU - Cylinder ${i}`,
  })),

  {
    name: "complaintsIfAny",
    type: "autocomplete",
    label: "Complaint Code",
    options: complaintCodes,
    placeholder: "Select Complaint Code",
  },
  {},
  {},
  {
    name: "implementsUsed",
    type: "textarea",
    label: "Implements Used",
    placeholder: "Enter Implements Used",
  },
  {
    name: "observation",
    type: "textarea",
    label: "Observation",
    placeholder: "Enter Observation",
  },
  {
    name: "actionTaken",
    type: "textarea",
    label: "Action Taken",
    placeholder: "Enter Action Taken",
  },
  {
    name: "customerFeedbackRemarks",
    type: "textarea",
    label: "Customer Feedback Remarks",
    placeholder: "Enter Customer Feedback Remarks",
  },
  {
    name: "remarks",
    type: "textarea",
    label: "Remarks",
    placeholder: "Enter Remarks",
  },
];
